import React from 'react'

function Singledimarray() {
  return (
    <div className='container'>
      <iframe className='w-100'height="500px" src="https://cpprogrames.blogspot.com/2021/05/single-dimensional-array.html" frameborder="0"></iframe>
    </div>
  )
}

export default Singledimarray